import styled from 'styled-components';

export const LoadingBoxWrapper = styled.div`
  height: 4rem;
`;
